import axios from 'axios';
import { createSignedPostRequest } from 'utils/createSignedRequestsHelpers';

export const copyTimelineService = async (projectId, timelineId) => {
  const apiPath = `timelines/project/${projectId}/timeline/${timelineId}/copy-to-project`;

  const signedRequest = await createSignedPostRequest({
    apiPath,
    body: {},
  });
  const response = await axios(signedRequest);
  return response.data;
};
